<div class="default-dialog-layout">
    <div class="title">Add group</div>

    <div class="content">
        <form #saveSelectionForm (ngSubmit)="confirm()">
            <cds-tree>
                <ng-template #recursiveSelectionTree let-nodes let-isTopLevel="isTopLevel">
                    <ng-container *ngFor="let node of nodes">
                        <cds-tree-item
                            *ngIf="!isTopLevel || hasChildren(node)"
                            [expanded]="node.show"
                            [expandable]="hasChildren(node)"
                            (expandedChange)="toggleNode(node)"
                        >
                            <ng-container>
                                <cds-checkbox>
                                    <label>{{ node.id }}</label>
                                    <input
                                        type="checkbox"
                                        [ngModel]="node.selected"
                                        (ngModelChange)="selectSelection(node)"
                                        [name]="'checkbox_' + node.id"
                                    />
                                </cds-checkbox>
                            </ng-container>
                            <ng-container *ngIf="node.show && hasChildren(node)">
                                <ng-container
                                    *ngTemplateOutlet="
                                        recursiveSelectionTree;
                                        context: { $implicit: node.nodes, isTopLevel: false }
                                    "
                                >
                                </ng-container>
                            </ng-container>
                        </cds-tree-item>
                    </ng-container>
                </ng-template>

                <ng-container
                    *ngTemplateOutlet="
                        recursiveSelectionTree;
                        context: { $implicit: nodes, isTopLevel: true }
                    "
                >
                </ng-container>
            </cds-tree>
            <div class="actions action-buttons form-action-buttons">
                <cds-button size="sm" type="button" action="flat" (click)="cancel()"
                    >Cancel</cds-button
                >
                <cds-button size="sm" [disabled]="!saveSelectionForm.checkValidity()" type="submit">
                    Save
                </cds-button>
            </div>
        </form>
    </div>
</div>
